import { BiCardData, BiDashboardView } from '@euler/model/bi/dashboard';

// Captured from the dev rear (store 323, member 3855) over the BiService hop:
// the dashboard as created, and each card's data.

export const kBiComboDashboardCaptured = {
  id: 'bidash_01m542jaw8393xexr8bmpaz3gx',
  name: '组合图测试',
  description: null,
  visibility: 1,
  ownerMemberId: 3855,
  ownerName: '测试店长',
  isDefault: false,
  revision: 1,
  permission: 'manage',
  updatedAt: '2026-10-17T04:40:20.000Z',
  layout: {
    mode: 'preset',
    columns: 'auto',
    order: [
      'bicard_01m542jaynx9jfyy11jq478wrw',
      'bicard_01m542jaypn71qh1xx44095js5',
      'bicard_01m542jaype08awfvy2k9x1ss7',
    ],
  },
  filters: {},
  palette: 'default',
  cards: [
    {
      id: 'bicard_01m542jaynx9jfyy11jq478wrw',
      title: '每月工单数与平均时长',
      spec: {
        dataset: {
          kind: 'sql',
          model: 'orders',
        },
        measures: [
          {
            kind: 'field',
            field: 'order_count',
          },
          {
            kind: 'field',
            field: 'turnaround',
            agg: 'avg',
          },
        ],
        dimensions: [
          {
            field: 'created_at',
            grain: 'month',
          },
        ],
        filters: [],
        sort: [],
        timeRange: {
          kind: 'relative',
          preset: 'last_12_months',
        },
      },
      viz: {
        type: 'bar',
        x: 'created_at__month',
        series: [
          {
            key: 'order_count',
          },
          {
            key: 'turnaround__avg',
            as: 'line',
            axis: 'right',
          },
        ],
        style: {
          axes: {
            y: {
              show: true,
              label: '工单数',
            },
            y2: {
              show: true,
              label: '平均时长（分钟）',
            },
          },
        },
      },
      sourceDraftId: 'bidraft_01m542jax0225gy5yycsynnwqz',
      createdBy: 3855,
      createdAt: '2026-10-17T04:40:20.000Z',
      updatedAt: '2026-10-17T04:40:20.000Z',
    },
    {
      id: 'bicard_01m542jaype08awfvy2k9x1ss7',
      title: '每周开单（面积）与完工（折线）',
      spec: {
        dataset: {
          kind: 'sql',
          model: 'orders',
        },
        measures: [
          {
            kind: 'field',
            field: 'order_count',
          },
          {
            kind: 'field',
            field: 'finished_count',
          },
        ],
        dimensions: [
          {
            field: 'created_at',
            grain: 'week',
          },
        ],
        filters: [],
        sort: [],
        timeRange: {
          kind: 'absolute',
          from: '2026-02-01',
          to: '2026-05-31',
        },
      },
      viz: {
        type: 'line',
        x: 'created_at__week',
        series: [
          {
            key: 'order_count',
            as: 'area',
          },
          {
            key: 'finished_count',
          },
        ],
      },
      sourceDraftId: 'bidraft_01m542jaycac065zhhy8ygbx9n',
      createdBy: 3855,
      createdAt: '2026-10-17T04:40:20.000Z',
      updatedAt: '2026-10-17T04:40:20.000Z',
    },
    {
      id: 'bicard_01m542jaypn71qh1xx44095js5',
      title: '每月完工、取消与车辆数',
      spec: {
        dataset: {
          kind: 'sql',
          model: 'orders',
        },
        measures: [
          {
            kind: 'field',
            field: 'finished_count',
          },
          {
            kind: 'field',
            field: 'cancelled_count',
          },
          {
            kind: 'field',
            field: 'vehicle_count',
          },
          {
            kind: 'field',
            field: 'turnaround',
            agg: 'avg',
          },
        ],
        dimensions: [
          {
            field: 'created_at',
            grain: 'month',
          },
        ],
        filters: [],
        sort: [],
        timeRange: {
          kind: 'relative',
          preset: 'last_12_months',
        },
      },
      viz: {
        type: 'stacked_bar',
        x: 'created_at__month',
        series: [
          {
            key: 'finished_count',
          },
          {
            key: 'cancelled_count',
          },
          {
            key: 'vehicle_count',
            as: 'line',
          },
          {
            key: 'turnaround__avg',
            as: 'line',
            axis: 'right',
          },
        ],
        style: {
          legend: {
            show: true,
            position: 'top',
          },
        },
      },
      sourceDraftId: 'bidraft_01m542jaxryp21cnj3d678ytaq',
      createdBy: 3855,
      createdAt: '2026-10-17T04:40:20.000Z',
      updatedAt: '2026-10-17T04:40:20.000Z',
    },
  ],
  createdAt: '2026-10-17T04:40:20.000Z',
} as unknown as BiDashboardView;

export const kBiComboCardDataCaptured = {
  bicard_01m542jaynx9jfyy11jq478wrw: {
    state: 'ready',
    cardId: 'bicard_01m542jaynx9jfyy11jq478wrw',
    result: {
      current: {
        columns: [
          {
            key: 'created_at__month',
            label: {
              zh: '开单时间（月）',
              en: 'Opened at (month)',
            },
            type: 'string',
            role: 'dimension',
          },
          {
            key: 'order_count',
            label: {
              zh: '工单数',
              en: 'Orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
          {
            key: 'turnaround__avg',
            label: {
              zh: '交付时长（平均）',
              en: 'Turnaround (average)',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'duration' },
          },
        ],
        rows: [
          ['2025-11', 1494, 2148.2481],
          ['2025-12', 1501, 2349.6612],
          ['2026-01', 1687, 1631.9066],
          ['2026-02', 1643, 2410.0985],
          ['2026-03', 1579, 2096.0124],
          ['2026-04', 1407, 2062.6216],
          ['2026-05', 1236, 1601.129],
        ],
        truncated: false,
        asOf: '2026-10-17T04:40:20.194Z',
        window: {
          from: '2025-11-01',
          to: '2026-10-31',
        },
      },
    },
    dateFilter: 'none',
  },
  bicard_01m542jaype08awfvy2k9x1ss7: {
    state: 'ready',
    cardId: 'bicard_01m542jaype08awfvy2k9x1ss7',
    result: {
      current: {
        columns: [
          {
            key: 'created_at__week',
            label: {
              zh: '开单时间（周）',
              en: 'Opened at (week)',
            },
            type: 'string',
            role: 'dimension',
          },
          {
            key: 'order_count',
            label: {
              zh: '工单数',
              en: 'Orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
          {
            key: 'finished_count',
            label: {
              zh: '已完工数',
              en: 'Finished orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
        ],
        rows: [
          ['2026-01-26', 84, 83],
          ['2026-02-02', 530, 515],
          ['2026-02-09', 459, 446],
          ['2026-02-16', 130, 122],
          ['2026-02-23', 532, 518],
          ['2026-03-02', 413, 403],
          ['2026-03-09', 350, 340],
          ['2026-03-16', 305, 298],
          ['2026-03-23', 340, 328],
          ['2026-03-30', 297, 288],
          ['2026-04-06', 362, 351],
          ['2026-04-13', 307, 293],
          ['2026-04-20', 333, 324],
          ['2026-04-27', 328, 320],
          ['2026-05-04', 378, 367],
          ['2026-05-11', 327, 315],
          ['2026-05-18', 313, 284],
          ['2026-05-25', 77, 43],
        ],
        truncated: false,
        asOf: '2026-10-17T04:40:20.216Z',
        window: {
          from: '2026-02-01',
          to: '2026-05-31',
        },
      },
    },
    dateFilter: 'none',
  },
  bicard_01m542jaypn71qh1xx44095js5: {
    state: 'ready',
    cardId: 'bicard_01m542jaypn71qh1xx44095js5',
    result: {
      current: {
        columns: [
          {
            key: 'created_at__month',
            label: {
              zh: '开单时间（月）',
              en: 'Opened at (month)',
            },
            type: 'string',
            role: 'dimension',
          },
          {
            key: 'finished_count',
            label: {
              zh: '已完工数',
              en: 'Finished orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
          {
            key: 'cancelled_count',
            label: {
              zh: '已取消数',
              en: 'Cancelled orders',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
          {
            key: 'vehicle_count',
            label: {
              zh: '车辆数',
              en: 'Vehicles',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'number', decimals: 0 },
          },
          {
            key: 'turnaround__avg',
            label: {
              zh: '交付时长（平均）',
              en: 'Turnaround (average)',
            },
            type: 'number',
            role: 'measure',
            format: { kind: 'duration' },
          },
        ],
        rows: [
          ['2025-11', 1455, 39, 1414, 2148.2481],
          ['2025-12', 1473, 28, 1428, 2349.6612],
          ['2026-01', 1648, 39, 1582, 1631.9066],
          ['2026-02', 1594, 49, 1580, 2410.0985],
          ['2026-03', 1536, 34, 1483, 2096.0124],
          ['2026-04', 1361, 34, 1315, 2062.6216],
          ['2026-05', 1147, 20, 1159, 1601.129],
        ],
        truncated: false,
        asOf: '2026-10-17T04:40:20.230Z',
        window: {
          from: '2025-11-01',
          to: '2026-10-31',
        },
      },
    },
    dateFilter: 'none',
  },
} as unknown as Record<string, BiCardData>;
